module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAASklEQVQ4y2NgGBxAN+k/OkYH5wTVMPBwMuA/DnDz7v3/a9dvxiVN2ICamdP/zy1sJN+AefOm/J9UXEbYAGz+w1CMJZyGkwFDGwAANtqu9PVY0TMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/DO.png
// module id = 1126
// module chunks = 0